import { cn } from '../../helpers/classnames'

export interface JosefSimpleRadioProps {
  name: string
  value: string
  checked: boolean
  onChange: () => void
  disabled?: boolean
  label: string
  className?: string
}

export function JosefSimpleRadio({
  name,
  value,
  checked,
  onChange,
  disabled = false,
  label,
  className = '',
}: JosefSimpleRadioProps) {
  return (
    <div className={cn('flex items-center gap-3', className)}>
      <div className="relative">
        <input
          type="radio"
          id={`${name}-${value}`}
          name={name}
          value={value}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          className="sr-only"
        />
        <div
          onClick={disabled ? undefined : onChange}
          className={cn(
            'aspect-square size-4 shrink-0 rounded-full border transition-all cursor-pointer outline-none',
            'border-black/20 dark:border-white/20 bg-white dark:bg-black',
            'focus-within:ring-2 focus-within:ring-black/20 dark:focus-within:ring-white/20',
            'hover:border-black/40 dark:hover:border-white/40',
            checked && 'border-black dark:border-white',
            disabled && 'opacity-50 cursor-not-allowed'
          )}
        >
          {checked && (
            <div className="relative flex items-center justify-center h-full">
              <div className="size-2 rounded-full bg-black dark:bg-white" />
            </div>
          )}
        </div>
      </div>
      <label
        htmlFor={`${name}-${value}`}
        onClick={disabled ? undefined : onChange}
        className={cn(
          'text-sm text-black dark:text-white cursor-pointer select-none',
          disabled && 'opacity-50 cursor-not-allowed'
        )}
      >
        {label}
      </label>
    </div>
  )
}

export default JosefSimpleRadio